export default __webpack_public_path__ + "static/media/memoryLossIcon.cac13952.svg";